export default __webpack_public_path__ + "static/media/greenArgo.1e218c62.svg";